import LegalPageLayout from "@/components/feature/LegalPageLayout";
import PrivacySections from "./components/PrivacySections";
import Seo from "@/components/feature/Seo";
import { seoMeta } from "@/lib/seo";

export default function PrivacyPolicy() {
  return (
    <>
      <Seo title={seoMeta.privacy.title} description={seoMeta.privacy.description} />
      <LegalPageLayout
        kicker="PRIVACY POLICY"
        title="プライバシーポリシー"
        meta="制定日:2026年8月1日"
      >
        <PrivacySections />
      </LegalPageLayout>
    </>
  );
}